import React from "react";
import Base from "./Base";

function App() {
  return <Base />;
}

export default App;
